import { z } from 'zod';
import { localeSchema } from './common';

/** OWASP minimum bez pretjerivanja: duljina radi više od simbola. */
export const passwordSchema = z
  .string()
  .min(10, 'Lozinka mora imati barem 10 znakova')
  .max(200);

export const registerInput = z.object({
  email: z.string().email().toLowerCase().trim(),
  password: passwordSchema,
  firstName: z.string().min(1).max(80),
  lastName: z.string().min(1).max(80).optional(),
  locale: localeSchema.default('hr'),
  acceptTerms: z.literal(true),
});

export const loginInput = z.object({
  email: z.string().email().toLowerCase().trim(),
  password: z.string().min(1),
});

export const forgotInput = z.object({ email: z.string().email().toLowerCase().trim() });
export const resetInput = z.object({ token: z.string().min(10), password: passwordSchema });
export const verifyEmailInput = z.object({ token: z.string().min(10) });

/** Native klijent šalje refresh token u tijelu; web ga ima u HttpOnly kolačiću. */
export const refreshBodyInput = z.object({ refreshToken: z.string().min(10) });

export const sessionOutput = z.object({
  accessToken: z.string(),
  expiresIn: z.number().int(),
  /** Prisutno samo za native klijente (zaglavlje x-client-platform: ios|android). */
  refreshToken: z.string().optional(),
  user: z.object({
    id: z.string(),
    email: z.string(),
    role: z.enum(['client', 'trainer', 'admin']),
    locale: localeSchema,
    emailVerified: z.boolean(),
    onboardingCompleted: z.boolean(),
    firstName: z.string().nullable(),
  }),
});

export type RegisterInput = z.infer<typeof registerInput>;
export type LoginInput = z.infer<typeof loginInput>;
export type SessionOutput = z.infer<typeof sessionOutput>;
